// Is used for new layout

import {
	CUSTOM_PROPERTY_TYPE,
	DEFAULT_FIELD_NAME,
	FIELD_NAME,
	SELECTION_TYPE,
	TYPE_CUSTOM_FIELD,
} from "constants/common";
import { WidgetFieldTypes, WidgetSectionTypes } from "models/DynamicWidget";
import { findFieldByFieldName } from "./widgetBuilder";
import { UploadRequestPayloadTypes } from "models/Widget";

export const formatFormValues = (
	values: UploadRequestPayloadTypes,
	sections: WidgetSectionTypes[],
) => {
	const result: any = {};
	const STANDARD_FIELDS = Object.values(FIELD_NAME);
	STANDARD_FIELDS.push(DEFAULT_FIELD_NAME.mailingAddress);
	STANDARD_FIELDS.push(FIELD_NAME.description);

	Object.keys(values).forEach((key) => {
		const value = values[key];
		if (!STANDARD_FIELDS.includes(key)) {
			let field = findFieldByFieldName(sections, key);
			const { type = "", name: placeholder = "", label: name = "", answerType = "" } = field || {};
			const addedValue = {
				values: value,
				...field,
				placeholder,
				name,
				isTaggable: false,
				isSearchable: true,
			};
			field = { ...field, ...addedValue };
			if (type === TYPE_CUSTOM_FIELD.dropdown) {
				field = {
					...field,
					values: answerType === SELECTION_TYPE.MULTIPLE ? value : [value],
					isTaggable: true,
				};
			}
			if (field.mapping === CUSTOM_PROPERTY_TYPE.CONTENT) {
				if (result?.contentCustomProperties?.length) {
					const findIndex = result?.contentCustomProperties?.findIndex(
						(item: WidgetFieldTypes) => item.key === field.key,
					);
					if (findIndex !== -1) {
						result.contentCustomProperties[findIndex] = field;
					} else result.contentCustomProperties.push(field);
				} else {
					result.contentCustomProperties = [];
					result.contentCustomProperties.push(field);
				}
			} else {
				if (result?.creatorCustomProperties?.length) {
					const findIndex = result?.creatorCustomProperties?.findIndex(
						(item: WidgetFieldTypes) => item.key === field.key,
					);
					if (findIndex !== -1) {
						result.creatorCustomProperties[findIndex] = field;
					} else result.creatorCustomProperties.push(field);
				} else {
					result.creatorCustomProperties = [];
					result.creatorCustomProperties.push(field);
				}
			}
			return;
		} else {
			result[key] = values[key];
		}
	});

	return result;
};
